<div class="header">
  <h1>
    {{ supplier.name }} Returns
    <img [src]="supplier.config?.logo" *ngIf="supplier.config?.logo" [alt]="supplier.name" />
  </h1>
  <p>{{ supplier.config?.returnDescription }}</p>
</div>

<div class="container">
  <span class="info">Type in your address</span>

  <div class="search">
    <div class="form-group">
      <input
        type="search"
        [formControl]="searchTerm"
        placeholder=" "
        required
        minlength="3"
        autocomplete="false"
        [class.invalid]="searchTerm.dirty && !searchTerm.valid"
      />
      <label>Your address</label>
      <i class="search-icon"></i>
    </div>
    <div #suggestionsElm class="suggestions" *ngIf="autofillSuggestions$ | async as suggestions">
      <div
        class="suggestion"
        *ngFor="let suggestion of suggestions"
        (click)="selectAddress.emit(suggestion.place_name)"
      >
        {{ suggestion.place_name }}
      </div>
    </div>
  </div>
</div>

<button class="back-btn" (click)="navigate.emit(['/'])" *ngIf="!automaticSelection">Back</button>
